/**
 * Available APIs and their labels. Add new kinds here; the type and
 * filter options derive from these keys in declaration order.
 */
export const API_LABEL = {
  saved: "Saved Search",
  adhoc: "Ad Hoc Search",
  firehose: "Firehose",
};

export type ApiKind = keyof typeof API_LABEL;
